import * as _ from 'underscore'

import { Enums } from '../../models/common'

import { UserSessionService, USER_SESSION_SERVICE_NAME } from '../user-session'
import { GridService, GRID_SERVICE_NAME } from '../grid'
import { ColumnModel } from '../../modules/api/api.models'
import { OpDistributor, OpSupplier, OpView, OpViewColumn } from '../../models/core'
import { GetViewColumnOptions } from '../../models/core/op-view'


//#region Public Types

export const DISTRIBUTOR_SUPPLIER_SERVICE_NAME = 'DistributorSupplierService'
export const DISTRIBUTOR_SUPPLIER_SERVICE_PROVIDER_NAME = 'DistributorSupplierServiceProvider'

//#endregion


export class DistributorSupplierService {

    //#region Ctor

    public constructor(
        private userSessionService: UserSessionService,
        private gridService: GridService
    ) { }

    //#endregion


    //#region SupplierColumns

    public getDistributorSuppliersColumns(): JQueryPromise<ColumnModel[]> {

        return this.userSessionService
            .getDataProvider()
            .View
            .getActiveView(Enums.ReferenceType.IdSupplier)
            .then((view: OpView) => {
                const columnParams: GetViewColumnOptions = new GetViewColumnOptions(Enums.DataType.HELPER_NAME)
                const viewColumn: OpViewColumn = view.getViewColumn(columnParams)

                const column: ColumnModel = new ColumnModel()
                column.idName = viewColumn.name.toLowerCase()
                column.name = viewColumn.name
                column.caption = viewColumn.caption
                column.id = viewColumn.idDataType

                return [column]
            })
    }
    //#endregion

    //#region Save

    public onSaveDistributorSuppliers(distributorToSave: OpDistributor, added: any[], removed: any[], inGrid: any[]): JQueryPromise<OpDistributor> {

        if (distributorToSave.currentSuppliers == null) {
            distributorToSave.currentSuppliers = []
        }

        if (_.size(added) > 0) {
            added.forEach((addedSupplier: any) => {
                const supplier: OpSupplier = new OpSupplier(null)
                supplier.idSupplier = addedSupplier.id
                supplier.opState = Enums.OpChangeState.New

                distributorToSave.currentSuppliers.push(supplier)
            })
        }

        if (_.size(removed) > 0) {
            removed.forEach((removedSupplier: any) => {
                const toRemove: OpSupplier = distributorToSave.currentSuppliers.find((supplier: OpSupplier) => supplier.idSupplier == removedSupplier.idSupplier)

                if (toRemove != null) {
                    toRemove.opState = Enums.OpChangeState.Delete
                }
            })
        }

        const toSave: OpDistributor = new OpDistributor(null)
        toSave.idDistributor = distributorToSave.idDistributor
        toSave.opState = Enums.OpChangeState.Loaded
        toSave.currentSuppliers = distributorToSave.currentSuppliers

        return this.userSessionService
            .getDataProvider()
            .Distributor
            .saveDistributor(toSave)
    }

    ////#endregion
}

export class DistributorSupplierServiceProvider implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [
        USER_SESSION_SERVICE_NAME,
        GRID_SERVICE_NAME,
        function (
            userSession: UserSessionService,
            gridService: GridService
        ) {
            return new DistributorSupplierService(
                userSession,
                gridService
            )
        }]

    //#endregion
} 